import _ from 'lodash';
import React from 'react';

import {Spacer} from '../../../../index';

import {Radio, RadioOption} from './Radio';

/**
 * A utility {@link Radio} component that uses {@link options} to render a list of radio options.
 *
 * This component must be used within a <Formik> component.
 *
 * @param {object} param0
 * @param {boolean?} [param0.disabled] Whether the radio is disabled.
 * @param {boolean?} [param0.horizontal] If `true`, options are displayed horizontally (and wrap if needed).
 * @param {React.ReactNode?} param0.label The (optional) label to display above the field.
 * @param {string} param0.name The name of the field to use in the form.
 * @param {Array<{value: string, label: React.ReactNode, level?: number}>} param0.options The list of options to display.
 *  See {@link RadioOption} for details about these arguments.
 */
export const ListRadio = ({disabled, horizontal, label, name, options}) => {
    return (
        <Radio name={name} label={label}>
            {horizontal ? (
                <Spacer.Align space="sm">
                    {_.map(options, (option) => (
                        <RadioOption {...option} key={option.value} disabled={disabled} name={name} />
                    ))}
                </Spacer.Align>
            ) : (
                _.map(options, (option) => (
                    <RadioOption {...option} key={option.value} disabled={disabled} name={name} />
                ))
            )}
        </Radio>
    );
};
